// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .dropDowntmplContent .selectTemplateDropdowm {
  border: 1px solid var(--sdk-chat-window-dropdown-border);
  height: 25px;
  background: var(--sdk-chat-window-bg-color);
  width: 100%;
  cursor: pointer;
}

.kore-chat-window .dropDowntmplContent .templateHeading {
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: bold;
  color: var(--sdk-chat-widow-primary-font-color);
}`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/dropdownTemplate/dropdownTemplate.scss"],"names":[],"mappings":"AAAA;EACI,wDAAA;EACA,YAAA;EACA,2CAAA;EACA,WAAA;EACA,eAAA;AACJ;;AACA;EACI,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,+CAAA;AAEJ","sourcesContent":[".kore-chat-window .dropDowntmplContent .selectTemplateDropdowm{\n    border: 1px solid var(--sdk-chat-window-dropdown-border);\n    height: 25px;\n    background: var(--sdk-chat-window-bg-color);\n    width: 100%;\n    cursor: pointer;\n}\n.kore-chat-window .dropDowntmplContent .templateHeading{\n    margin-bottom: 10px;\n    font-size: 12px;\n    font-weight: bold;\n    color: var(--sdk-chat-widow-primary-font-color);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
